import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/svg/icon_location.svg'
import _imports_1 from '@/assets/svg/icon_mail.svg'
import _imports_2 from '@/assets/svg/whatsapp.svg'


const _hoisted_1 = { class: "flex flex-col l:flex-row px-10 l:px-0 l:gap-x-[240px] justify-center l:items-start mt-[40px] mb-[76px] l:max-w-[1362px] l:mx-auto" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "flex items-center justify-center" }
const _hoisted_4 = { class: "flex flex-col gap-y-3 mb-[60px]" }
const _hoisted_5 = { class: "flex items-center" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  class: "w-[27px] l:w-[46px]"
}, null, -1)
const _hoisted_7 = { class: "p-[10px]" }
const _hoisted_8 = { class: "flex flex-col gap-y-5 l:flex-row l:items-center gap-x-3" }
const _hoisted_9 = {
  href: "mailto:reserv@rvm-spb.ru",
  class: "flex items-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-[27px] l:w-[46px]"
}, null, -1)
const _hoisted_11 = { class: "px-[15px] py-[10px]" }
const _hoisted_12 = {
  href: "tel:+79112660098",
  class: "flex items-center"
}
const _hoisted_13 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  class: "w-[27px] l:w-[46px]"
}, null, -1)
const _hoisted_14 = { class: "px-[15px] py-[10px]" }
const _hoisted_15 = { class: "flex items-center" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  class: "w-[27px] l:w-[46px]"
}, null, -1)
const _hoisted_17 = { class: "p-[10px]" }
const _hoisted_18 = { href: "mailto:info@rvm-spb.ru" }
const _hoisted_19 = { class: "flex items-center justify-center flex-col" }
const _hoisted_20 = { class: "flex flex-col gap-y-4" }
const _hoisted_21 = { class: "flex flex-col l:grid l:grid-cols-[auto_800px] gap-y-[60px] l:mb-[104px]" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useWindowSize } from '@vueuse/core';
import BaseTypography from '@/components/common/BaseTypography.vue';
import BaseButton from '@/components/common/BaseButton.vue';
import BaseReturn from '@/components/common/BaseReturn.vue';
import Form from './Form.vue';
import Map from './Map.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'Contacts',
  setup(__props) {

const { width } = useWindowSize();
const { t } = useI18n();

const mobile = computed(() => width.value < 768);
const typoMobile = computed(() => (mobile.value ? 'body-m' : 'body'));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(BaseReturn, {
          text: _unref(t)('contacts.title')
        }, null, 8, ["text"]),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("div", _hoisted_7, [
                _createVNode(BaseTypography, {
                  text: _unref(t)('contacts.address.first'),
                  type: typoMobile.value
                }, null, 8, ["text", "type"]),
                _createVNode(BaseTypography, {
                  text: _unref(t)('contacts.address.second'),
                  type: typoMobile.value
                }, null, 8, ["text", "type"]),
                _createVNode(BaseTypography, {
                  text: _unref(t)('contacts.address.third'),
                  type: typoMobile.value
                }, null, 8, ["text", "type"])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("a", _hoisted_9, [
                _hoisted_10,
                _createElementVNode("div", _hoisted_11, [
                  _createVNode(BaseTypography, {
                    text: "reserv@rvm-spb.ru",
                    type: typoMobile.value
                  }, null, 8, ["type"])
                ])
              ]),
              _createElementVNode("a", _hoisted_12, [
                _hoisted_13,
                _createElementVNode("div", _hoisted_14, [
                  _createVNode(BaseTypography, {
                    text: "+7 (911) 266-00-98",
                    type: typoMobile.value
                  }, null, 8, ["type"])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_15, [
              _hoisted_16,
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("a", _hoisted_18, [
                  _createVNode(BaseTypography, {
                    text: "info@rvm-spb.ru",
                    type: typoMobile.value
                  }, null, 8, ["type"])
                ])
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_19, [
        _createVNode(BaseButton, {
          text: _unref(t)('contacts.subtitle'),
          type: mobile.value ? 'subtitle-m' : 'subtitle',
          ui: "primary",
          "padding-x": "63.5",
          "padding-y": "11.5",
          color: "var(--black-color)",
          class: "mb-12"
        }, null, 8, ["text", "type"]),
        _createElementVNode("div", _hoisted_20, [
          _createVNode(BaseTypography, {
            text: _unref(t)('contacts.schedule.first'),
            type: typoMobile.value
          }, null, 8, ["text", "type"]),
          _createVNode(BaseTypography, {
            text: _unref(t)('contacts.schedule.second'),
            type: typoMobile.value
          }, null, 8, ["text", "type"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_21, [
      _createVNode(Map, { class: "m:h-[600px] w-full" }),
      _createVNode(Form, { class: "l:h-[600px] l:w-[800px]" })
    ])
  ], 64))
}
}

})